import { FundingSource } from '../../Nomination/components/NominationForm/FundingModule/types';

export const APPLICANT_APPLIY_SCHOLARSHIPS = [
  FundingSource.HONGKONG_PHD_FELLOWSHIP_SCHEME,
  FundingSource.POLYU_PRESIDENTIAL_PHD_FELLOWSHIP_SCHEME,
  FundingSource.INTERNATIONAL_PHD_FELLOWSHIP_SCHEME,
];
